export default __webpack_public_path__ + "static/media/ISEO_CLASS-2_SYLLABUS_2025-26.fc82d874.pdf";